import { EToastPlacement } from './enums'

export function setupPlugin(Vue, defaultPlacement = EToastPlacement.TOP_RIGHT) {
  return function (ctx, inject) {
    const state = Vue.observable({
      messages: [],
      placement: defaultPlacement,
      show: false,
      timeout: 3000,
      type: 'success',
    })

    const toastManager = {
      get messages() {
        return state.messages
      },

      get placement() {
        return state.placement
      },

      get timeout() {
        return state.timeout
      },

      get type() {
        return state.type
      },

      get show() {
        return state.show
      },

      set show(show) {
        state.show = show
      },

      fire(messages, { placement = defaultPlacement, timeout = 3000, type = 'success' } = {}) {
        state.messages = typeof messages === 'string' ? [messages] : messages

        state.placement = placement
        state.type = type

        // reset the timeout
        state.timeout = -1
        setTimeout(() => state.timeout = timeout)

        state.show = true
      }
    }

    inject('toast', toastManager)
  }
}
